import { jsx as _jsx, jsxs as _jsxs, Fragment as _Fragment } from "react/jsx-runtime";
import { convert24hrTo12HrFormat } from './time';
export const renderTimetablesRange = (eventStart, eventEnd, is12HrFormat) => {
    const startTime = eventStart ? eventStart.slice(0, 5) : '';
    const endTime = eventEnd ? eventEnd.slice(0, 5) : '';
    return (_jsxs(_Fragment, { children: [_jsx("span", { children: is12HrFormat ? convert24hrTo12HrFormat(startTime) : startTime }, void 0), ' ', _jsxs("span", { children: [" - ", is12HrFormat ? convert24hrTo12HrFormat(endTime) : endTime] }, void 0)] }, void 0));
};
